import { BooksService, TownsServiceClient } from '../../generated/client';

export class BookServiceFactory {
  private static _bookservice: BooksService | undefined;

  private constructor() {
    BookServiceFactory._bookservice = undefined;
  }

  public static instance(): BooksService {
    const url = process.env.REACT_APP_TOWNS_SERVICE_URL;
    if (!BookServiceFactory._bookservice) {
      BookServiceFactory._bookservice = new TownsServiceClient({ BASE: url }).books;
    }
    return BookServiceFactory._bookservice;
  }
}
